<div class="tw-flex tw-justify-between tw-items-center tw-mb-3 tw-hidden">
  <span class="tw-text-lg tw-font-bold tw-text-base-text/60" translate>student.recommendations.labels.next_step</span>
  <div class="tw-flex tw-gap-1 tw-py-0.5 tw-px-2 tw-bg-base-text/[.08] tw-rounded-lg">
    <span class="tw-italic" translate>student.recommendations.labels.in_progress</span>
  </div>
</div>

<ng-container [ngSwitch]="view$ | async">
  <ng-container *ngSwitchCase="View.Loading">
    <st-recommendation-panel>
      <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-grow tw-gap-1">
        <kendo-loader class="tw-flex tw-items-center tw-h-7" type="pulsing" [themeColor]="'light'"></kendo-loader>
        <span class="tw-font-light tw-text-center" translate>student.recommendations.labels.loading</span>
      </div>
    </st-recommendation-panel>
  </ng-container>
  <ng-container *ngSwitchCase="View.Recommendations">
    <div>
      <st-recommendation
        *ngFor="let recommendation of allRecommendations$ | async; let i = index"
        [learning]="recommendation.url === (currentUrl$ | async)"
        [recommendation]="recommendation"
        [waitingForReward]="isWaitingForReward$(recommendation) | async"
      ></st-recommendation>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="View.NoRecommendations">
    <st-recommendation-panel>
      <div class="tw-flex tw-justify-center tw-items-center tw-grow tw-gap-1">
        <fa-icon class="tw-text-2xl tw-mx-2.5" [icon]="icons.faFaceSmileWink"></fa-icon>
        <span class="tw-font-light tw-leading-6" translate>student.recommendations.labels.no_recommendations</span>
      </div>
    </st-recommendation-panel>
  </ng-container>
  <ng-container *ngSwitchCase="View.LoadingFailed">
    <st-recommendation-panel>
      <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-grow tw-gap-1">
        <button
          kendoButton themeColor="base"
          class="tw-w-20 tw-h-7 tw-p-2 tw-bg-white tw-text-success tw-font-medium tw-rounded-lg tw-border-none"
          (click)="reloadRecommendations()"
        >
          <span class="tw-flex tw-gap-2 tw-items-center">
            <span translate>student.recommendations.actions.retry</span>
            <fa-icon [icon]="icons.faArrowsRotate"></fa-icon>
          </span>
        </button>
        <span class="tw-font-light tw-leading-6 tw-text-center" translate>student.recommendations.errors.loading</span>
      </div>
    </st-recommendation-panel>
  </ng-container>
</ng-container>

<div class="tw-grid tw-grid-cols-2 tw-gap-2 tw-hidden">
  <button
    kendoButton themeColor="base"
    class="tw-p-2 tw-bg-base-text/[.08] tw-text-base-text/[.65] tw-rounded-lg tw-border-none"
    (click)="onChangeSubject()"
  >
    <span class="tw-flex tw-flex-col tw-items-center">
      <fa-icon class="tw-text-xl" [icon]="icons.faCalculator"></fa-icon>
      <span translate>student.recommendations.actions.change_subject</span>
    </span>
  </button>
  <button
    kendoButton themeColor="base"
    class="tw-p-2 tw-bg-base-text/[.08] tw-text-base-text/[.65] tw-rounded-lg tw-border-none"
  >
    <span class="tw-flex tw-flex-col tw-items-center">
      <fa-icon class="tw-text-xl" [icon]="icons.faCircleQuestion"></fa-icon>
      <span translate>student.recommendations.actions.need_help</span>
    </span>
  </button>
</div>
